// extracted by mini-css-extract-plugin
export default {"header":"ItemCardHeader_header__dTQr7","small":"ItemCardHeader_small__rrZc0","name":"ItemCardHeader_name__vQgs8","price":"ItemCardHeader_price__pARX+"};